import axios from 'axios';

export const lunchApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/lunchs`,
    headers: {
        'Content-Type': 'application/json'
    }
})